import React, {
    useEffect,
    useState,
    useRef,
} from 'react';

export default function ViewInstanceDate({date, venue}) {
    

    return (
        <div className="view-alternative-dates">
            <div className="view-alternative-dates__title-row">
                <span className="view-alternative-dates__title">Date and time</span>
            </div>
            <div className='view-alternative-dates__paginate'>
                <div className='view-alternative-dates__details'>
                    {
                        date && <p className="view-alternative-dates__details-date">{ date }</p>
                    }
                    {
                        venue && <p className="view-alternative-dates__details-venue">{ venue }</p>
                    }
                    
                </div>
            </div>            
        </div>
    );
}